[
  {
    "id": "why_me",
    "question": "Why me? I was nobody.",
    "requiresKnowledge": ["met_the_spirit"],
    "dialogueId": "spirit_q_why_me",
    "lockedHint": "You have not met the spirit yet."
  },
  {
    "id": "what_are_you",
    "question": "What are you, exactly?",
    "requiresKnowledge": ["met_the_spirit"],
    "dialogueId": "spirit_q_what_are_you",
    "lockedHint": "You have not met the spirit yet."
  },
  {
    "id": "why_do_i_return",
    "question": "Why do I come back when I die?",
    "requiresKnowledge": ["died_once"],
    "dialogueId": "spirit_q_why_do_i_return",
    "lockedHint": "Ask after you have died at least once."
  },
  {
    "id": "does_anyone_else_remember",
    "question": "Am I the only one who remembers?",
    "requiresKnowledge": ["died_once", "spirit_explained_loop"],
    "dialogueId": "spirit_q_does_anyone_else_remember",
    "lockedHint": "Ask once the spirit has explained the loop to you."
  },
  {
    "id": "who_is_the_grey_man",
    "question": "Who is the grey man who knew my name?",
    "requiresKnowledge": ["met_anti_player"],
    "dialogueId": "spirit_q_who_is_the_grey_man",
    "lockedHint": "Ask after you have met him."
  },
  {
    "id": "can_he_be_killed",
    "question": "Can he be killed for good?",
    "requiresKnowledge": ["defeated_anti_player"],
    "dialogueId": "spirit_q_can_he_be_killed",
    "lockedHint": "Ask after you have beaten him in the field at least once."
  },
  {
    "id": "how_do_i_stop_him",
    "question": "If killing him will not end it, what will?",
    "requiresKnowledge": ["anti_player_identity_known", "anti_player_motivation_known"],
    "dialogueId": "spirit_q_how_do_i_stop_him",
    "lockedHint": "Ask once you know both who he is and what he wants."
  },
  {
    "id": "what_is_the_deadline",
    "question": "What happens on the five hundred and twelfth day?",
    "requiresKnowledge": ["survived_day_30"],
    "dialogueId": "spirit_q_what_is_the_deadline",
    "lockedHint": "Ask once you have lived long enough to be told there is a deadline."
  },
  {
    "id": "why_wont_they_believe_me",
    "question": "Why will nobody believe what I tell them?",
    "requiresKnowledge": ["died_once"],
    "dialogueId": "spirit_q_why_wont_they_believe_me",
    "lockedHint": "Ask after you have died at least once."
  },
  {
    "id": "what_of_the_necromancer",
    "question": "What is the Necromancer, and why the sun?",
    "requiresKnowledge": ["survived_day_30"],
    "dialogueId": "spirit_q_what_of_the_necromancer",
    "lockedHint": "Ask once you have lived long enough to be told there is a deadline."
  },
  {
    "id": "why_are_you_limited",
    "question": "Who set the limit on your tongue?",
    "requiresKnowledge": ["mastered_an_ability", "survived_day_30"],
    "dialogueId": "spirit_q_why_are_you_limited",
    "lockedHint": "Ask once you have mastered something and outlived the thirtieth day."
  },
  {
    "id": "does_any_of_it_count",
    "question": "The people I save — the loop unmakes them. Does any of it count?",
    "requiresKnowledge": ["survived_dawnmere_attack", "died_once"],
    "dialogueId": "spirit_q_does_any_of_it_count",
    "lockedHint": "Ask once you have saved Dawnmere at least once and lost it again."
  },
  {
    "id": "how_do_i_get_in",
    "question": "How does anyone actually get inside the Ebon Citadel?",
    "requiresKnowledge": ["reached_ebon_citadel"],
    "dialogueId": "spirit_q_how_do_i_get_in",
    "lockedHint": "Ask once you have stood before the citadel yourself."
  }
]
